





























































import { Component } from '@niknevis/vue-modules'
import PaymentGatewayConfirm from '@/modules/transaction/components/shared/payment/PaymentGatewayConfirm.vue'
import PaymentWalletConfirm from '@/modules/transaction/components/shared/payment/PaymentWalletConfirm.vue'
import {
  OwnBankInfoModel,
  PaymentLink,
  PaymentLinkRequest,
  PaymentMethods,
  StartPaymentResource
} from '@/modules/transaction/models/payment.model'
import { Notification } from '@/modules/notification/classes/notification'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { Prop, Watch } from 'vue-property-decorator'
import BillingInfoAlert from '@/modules/billing-info/components/panel/BillingInfoAlert.vue'
import PaymentType from '@/modules/transaction/components/shared/payment/PaymentType.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Vue from 'vue'
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import PreInvoice from '@/modules/transaction/components/shared/payment/PreInvoice.vue'


@Component({
  components: {
    PreInvoice,
    BillingInfoAlert,
    BaseCard,
    PaymentType,
    PaymentWalletConfirm,
    PaymentGatewayConfirm
  }
})
export default class FinalPayment extends Vue {
  @Prop() getPaymentResource!: (
    data: PaymentLinkRequest
  ) => Promise<StartPaymentResource>

  @Prop() billingInfo!: BillingInfoResourceModel
  @Prop() ownBankInfo!: OwnBankInfoModel
  @Prop() amount!: number
  @Prop() preInvoiceDownloadUrl!: string | URL
  @Prop({ default: 'برای ادامه بر روی دکمه پرداخت کلیک کنید.' }) walletPaymentMessage!: string
  @Prop({ default: 'برای ادامه بر روی دکمه پرداخت کلیک کنید.' }) onlinePaymentMessage!: string

  private paymentMethod: PaymentMethods = this._paymentMethod

  get _paymentMethod(): PaymentMethods {
    return (this.amount > 0)
      ? PaymentMethods.ONLINE
      : PaymentMethods.WALLET
  }

  walletConfirm = false
  gatewayConfirm = false

  startPayment: StartPaymentResource | null = null
  paymentLink: PaymentLink | null = null
  bankReceiptImage: Array<File> = []

  @Watch('amount')
  onAmountChange() {
    this.paymentMethod = this._paymentMethod
  }

  get scope() {
    return {
      onNextClick: this.onNextClick.bind(this),
      vm: this
    }
  }

  get paymentLinkUrl() {
    if (!this.paymentLink) return ''

    const url = new URL(this.paymentLink?.url)

    if (!Array.isArray(this.paymentLink.params)) {
      Object
        .keys(this.paymentLink.params)
        .forEach(key => {
          url.searchParams.set(key, this.paymentLink?.params[key])
        })
    }
    return url.toString()
  }

  async fetchGateway(data: Partial<PaymentLinkRequest> = {}) {
    const result = await this
      .getPaymentResource({
        ...data,
        gateway: this.paymentMethod
      })

    this.startPayment = result

    this.paymentLink = result.payment_link

    return result
  }

  async onNextClick() {
    switch (this.paymentMethod) {
      case PaymentMethods.ONLINE:
        await this.fetchGateway()
        this.gatewayConfirm = true
        break
      case PaymentMethods.WALLET:
        await this.fetchGateway()
        this.walletConfirm = true
        break
      case PaymentMethods.CARD:
        if (this.bankReceiptImage.length === 0) {
          return Notification.open({
            message: 'لطفا تصویر فیش واریزی را بارگذاری کنید.\n',
            type: 'warning'
          })
        }

        const result = await this.fetchGateway({
          attachment: this.bankReceiptImage[0]
        })

        Inertia.get(result.verify_url)

        break
    }
  }

  get isEnableOnline() {
    return this.amount > 0
  }

  get isEnableWallet() {
    return this.billingInfo?.type === BillingInfoType.NATURAL || this.amount == 0
  }

  get isEnableCard() {
    return this.amount > 0
  }
}
